<ion-content class="ion-no-padding">
  <form class="lead-form itinerary-model-container">
    <div class="itinerary-model-header">
      <ion-header class="ion-no-border ion-padding-horizontal sticky-top bg-white">
        <ion-toolbar class="header-first-toolbar">
          <ion-title class="text-start ion-no-padding title-blue"><span *ngIf="!editInventoryItineraray && !editQuoteItinerary"></span><span *ngIf="leadId && !editQuoteItinerary"> Quote</span> <span *ngIf="!leadId && !editInventoryItineraray"> Itinerary</span><span *ngIf="editQuoteItinerary">Edit Quote</span><span *ngIf="editInventoryItineraray">Edit Itinerary</span><span *ngIf="editInventoryItineraray"> ({{editInventoryItineraray}})</span><span *ngIf="editQuoteItinerary"> ({{editQuoteItinerary}})</span> <span *ngIf="leadDetails"> For {{leadDetails.firstName}} {{leadDetails.lastName}} ({{leadDetails.leadId}})</span></ion-title>
          <ion-buttons slot="end" class="ion-no-margin">
            
            <ion-button class="filled-blue-btn" (click)="submitQuote()" *ngIf="showSubmitButton()" [disabled]="checkCurrentFormDirty(componentView)">
              <ion-text>Submit</ion-text>
            </ion-button>
            <ion-button (click)="closeModal()" class="header-button-cancel unfilled-gray-btn">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
  
      <div class="dashed-line"></div>
  
      <div class="d-flex py-1 flex-wrap ion-padding-horizontal nav-buttons-container">
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'lead', 'tab-green': leadDetails?.dataSaved}"  (click)="onViewChangeFromTab('lead')" *ngIf="leadId">Lead</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'details', 'tab-green': detailsFormData?.dataSaved, 'tab-red': detailsFormData?.dataInvalid }" (click)="onViewChangeFromTab('details')" >Trip Details</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'route', 'tab-green': routeCraftFormData?.dataSaved, 'tab-red': routeCraftFormData?.dataInvalid }" (click)="onViewChangeFromTab('route')" [disabled]="!itineraryId" *ngIf="serviceBasedSections.showRouteCraft">Route</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'accommodation', 'tab-green': dmcHotelPricingFormData?.dataSaved, 'tab-red': dmcHotelPricingFormData?.dataInvalid}" (click)="onViewChangeFromTab('accommodation')" [disabled]="!itineraryId" *ngIf="serviceBasedSections.showHotels">Pricing</ion-button>      
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'addOnTickets', 'tab-green': addOnTicketsFormData?.dataSaved, 'tab-red': addOnTicketsFormData?.dataInvalid}" (click)="onViewChangeFromTab('addOnTickets')" [disabled]="!itineraryId">Add On Tickets</ion-button>      
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'inclusion', 'tab-green': inclusionsAndExclusionsFormData?.dataSaved}"  (click)="onViewChangeFromTab('inclusion')" [disabled]="!itineraryId">I&E</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'combined-terms', 'tab-green': termsAndConditionsFormData?.dataSaved}"  (click)="onViewChangeFromTab('combined-terms')" [disabled]="!itineraryId">T&C</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'important', 'tab-green': importantInformationFormData?.dataSaved}"  (click)="onViewChangeFromTab('important')" [disabled]="!itineraryId">Important Information</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'notes', 'tab-green': notesFormData?.dataSaved}"  (click)="onViewChangeFromTab('notes')" [disabled]="!itineraryId">Notes</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'templates-details', 'tab-green': templatesDetailsFormData?.dataSaved}"  (click)="onViewChangeFromTab('templates-details')" [disabled]="!itineraryId" *ngIf="leadId">Customize Template</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'review'}"  (click)="openReviewScreen()" [disabled]="!itineraryId">Review</ion-button>
      </div>
    </div>
    

    <div [ngSwitch]="componentView" class="itinerary-model-content-main">

      <app-dmc-quote-lead-details *ngSwitchCase="'lead'" [leadId]="leadId" [leadDetails]="leadDetails"
      (viewChange)="onViewChange($event)" 
      (updateLeadServices)="getLeadServices()"
      (tourPackageRemoved)="tourPackageRemovedImpact()"
      ></app-dmc-quote-lead-details>

      <app-dmc-quote-itinerary-details *ngSwitchCase="'details'" [leadId]="leadId" (viewChange)="onViewChange($event)" 
        (assignItineraryId)="assignItineraryId($event)" (storeFormData)="storeDetailsData($event)" [storedFormData]="detailsFormData" [itineraryId]="itineraryId"
        [editQuote]="editQuoteItinerary? true : false" 
        [serviceBasedSections]="serviceBasedSections" 
        (updateQuote)="updateQuote()"
        (totalDaysChanges)="impactDaysChange()" 
        (totalGuestsChanges)="impactGuestsChange()"
        (destinationChanges)="impactDestinationChanges()">
      </app-dmc-quote-itinerary-details>

      <app-dmc-quote-route-craft *ngSwitchCase="'route'" [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)" 
      (storeFormData)="storeRouteCraftData($event)" 
      (updateQuote)="updateQuote()" 
      [itineraryDetails]="detailsFormData" 
      [storedFormData]="routeCraftFormData" 
      [editQuote]="editQuoteItinerary? true : false"  
      [serviceBasedSections]="serviceBasedSections"
      ></app-dmc-quote-route-craft>

      <app-dmc-quote-hotel-pricing *ngSwitchCase="'accommodation'" [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)" 
      (storeFormData)="storeDmcHotelPricingData($event)" 
      (updateQuote)="updateQuote()" 
      [itineraryDetails]="detailsFormData" 
      [storedFormData]="dmcHotelPricingFormData" 
      [editQuote]="editQuoteItinerary? true : false"  
      ></app-dmc-quote-hotel-pricing>

      <app-dmc-quote-addon-tickets *ngSwitchCase="'addOnTickets'" [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)" 
      (storeFormData)="storeAddOnTicketsData($event)" 
      (updateQuote)="updateQuote()" 
      [itineraryDetails]="detailsFormData" 
      [storedFormData]="addOnTicketsFormData" 
      [editQuote]="editQuoteItinerary? true : false"
      ></app-dmc-quote-addon-tickets>

      <app-dmc-quote-inclusions-exclusions *ngSwitchCase="'inclusion'"  [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)" 
      (storeFormData)="storeInclusionsAndExclusionData($event)" 
      (updateQuote)="updateQuote()" 
      [storedFormData]="inclusionsAndExclusionsFormData" 
      [editQuote]="editQuoteItinerary? true : false"
      ></app-dmc-quote-inclusions-exclusions>

      <app-dmc-quote-combined-terms *ngSwitchCase="'combined-terms'"  [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)"  
      [cancellationPolicyFormData]="cancellationPolicyFormData"
      [termsAndConditionsFormData]="termsAndConditionsFormData"
      [paymentTermsAndConditionsFormData]="paymentTermsAndConditionsFormData" 
      (storeTermsFormData)="storeTermsAndConditionsData($event)"
      (storePaymentTermsFormData)="storePaymentTermsAndConditionsData($event)"
      (storeCancellationPolicyFormData)="storeCancellationPolicyData($event)"
      (updateQuote)="updateQuote()"
      [editQuote]="editQuoteItinerary? true : false"
      ></app-dmc-quote-combined-terms>

      <app-dmc-quote-important-information *ngSwitchCase="'important'" [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)" 
      (updateQuote)="updateQuote()" 
      (storeFormData)="storeImportantInformationData($event)" 
      [storedFormData]="importantInformationFormData" 
      [editQuote]="editQuoteItinerary? true : false" 
      ></app-dmc-quote-important-information>

      <app-dmc-quote-notes *ngSwitchCase="'notes'" [leadId]="leadId" [itineraryId]="itineraryId" 
      (viewChange)="onViewChange($event)" 
      (storeFormData)="storeNotesData($event)" 
      (updateQuote)="updateQuote()" 
      [storedFormData]="notesFormData" 
      [editQuote]="editQuoteItinerary? true : false" 
      ></app-dmc-quote-notes>

      <app-dmc-quote-template-data *ngSwitchCase="'templates-details'" [leadId]="leadId" [itineraryId]="itineraryId"
      (viewChange)="onViewChange($event)" 
      (openReviewScreen)="openReviewScreen()" 
      [templateId]="teamplateId"  
      (storeFormData)="storeTemplateDetailsData($event)" 
      (updateQuote)="updateQuote()" 
      [storedFormData]="templatesDetailsFormData"
      ></app-dmc-quote-template-data>

    </div>
  </form>
</ion-content>
